import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import {
  Badge,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import qs from "qs";
import { StoreContext } from "components/StoreContext";
import Query from "./Query";
import ProductSearchResult from "./ProductSearchResult";

const sortOptions = {
  "name-az": "Name A to Z",
  "name-za": "Name Z to A",
  "price-lh": "Price Low to High",
  "price-hl": "Price High to Low"
};

const Results = props => {
  const { loading, results, setFiltersVisibility, page, pages } = props;
  const search = qs.parse(window.location.search.substr(1));
  const { category, filter: filters, sort } = search;
  const [sortOpen, setSortOpen] = useState(false);
  const appliedFiltersCount =
    (filters ? Object.keys(filters).length : 0) + (category ? 1 : 0);
  const { config, getCategoryById } = useContext(StoreContext);
  const { ProductListSorting } = config.features;

  return (
    <section className="products__results">
      <div className="products__results-header">
        <div className="products__results-filters products__results-filters--lg">
          {appliedFiltersCount > 0 && (
            <div>
              <span>Applied Filters: </span>
              {category && (
                <Query
                  search={{
                    category: null,
                    page: null
                  }}
                  className="btn btn-sm btn-outline-primary"
                >
                  {getCategoryById(Number(category)).text}
                  <FontAwesomeIcon icon={faTimesCircle} />
                </Query>
              )}
              {filters &&
                Object.keys(filters).map(filter => (
                  <Query
                    key={filters[filter]}
                    search={{
                      filter: {
                        ...search.filter,
                        ...{ [filter]: null }
                      },
                      page: null
                    }}
                    className="btn btn-sm btn-outline-primary"
                  >
                    {filters[filter]}
                    <FontAwesomeIcon icon={faTimesCircle} />
                  </Query>
                ))}
              <Query
                search={{ category: null, filter: null, page: null }}
                className="btn btn-sm btn-link"
              >
                Clear All
              </Query>
            </div>
          )}
        </div>
        <div className="products__results-filters products__results-filters--sm">
          {appliedFiltersCount > 0 ? (
            <div>
              <Button
                outline
                color="primary"
                size="sm"
                onClick={() => setFiltersVisibility(true)}
              >
                <span>Filters</span>
                <Badge color="primary" className="ms-2">
                  {appliedFiltersCount}
                </Badge>
              </Button>
              <Query
                search={{ category: null, filter: null, page: null }}
                className="btn btn-sm btn-link"
              >
                Clear All
              </Query>
            </div>
          ) : (
            <Button
              outline
              color="primary"
              size="sm"
              onClick={() => setFiltersVisibility(true)}
            >
              <span>Filters</span>
            </Button>
          )}
        </div>
        <div className="products__results-sort">
          {ProductListSorting && (
            <ButtonDropdown
              isOpen={sortOpen}
              toggle={() => setSortOpen(!sortOpen)}
            >
              <DropdownToggle outline size="sm" color="primary" caret>
                {`Sort: ${sort ? sortOptions[sort] : "Featured"}`}
              </DropdownToggle>
              <DropdownMenu end>
                <Query
                  search={{ sort: null, page: null }}
                  className={`dropdown-item ${!sort ? "active" : ""}`}
                  tabIndex="0"
                  role="menuitem"
                  onClick={() => setSortOpen(false)}
                >
                  Featured
                </Query>
                <Query
                  search={{ sort: "price-hl", page: null }}
                  className={`dropdown-item ${
                    sort === "price-hl" ? "active" : ""
                  }`}
                  tabIndex="0"
                  role="menuitem"
                  onClick={() => setSortOpen(false)}
                >
                  Price High to Low
                </Query>
                <Query
                  search={{ sort: "price-lh", page: null }}
                  className={`dropdown-item ${
                    sort === "price-lh" ? "active" : ""
                  }`}
                  tabIndex="0"
                  role="menuitem"
                  onClick={() => setSortOpen(false)}
                >
                  Price Low to High
                </Query>
                <Query
                  search={{ sort: "name-az", page: null }}
                  className={`dropdown-item ${
                    sort === "name-az" ? "active" : ""
                  }`}
                  tabIndex="0"
                  role="menuitem"
                  onClick={() => setSortOpen(false)}
                >
                  Name A to Z
                </Query>
                <Query
                  search={{ sort: "name-za", page: null }}
                  className={`dropdown-item ${
                    sort === "name-za" ? "active" : ""
                  }`}
                  tabIndex="0"
                  role="menuitem"
                  onClick={() => setSortOpen(false)}
                >
                  Name Z to A
                </Query>
              </DropdownMenu>
            </ButtonDropdown>
          )}
        </div>
      </div>
      <div className="products__results-items">
        {results.map((product, i) => (
          <ProductSearchResult
            key={`${product.id + i}-${product.productName}`}
            id={product.id}
            productName={product.productName}
            productType={product.productType}
            sku={product.sku}
            shortDescription={product.shortDescription}
            partnerName={product.partnerName}
            partnerShortName={product.partnerShortName}
            partnerImage={product.partnerImage}
            partnerCode={product.partnerCode}
            image={product.image}
            isMobileAccessible={product.isMobileAccessible}
            licenseDuration={product.licenseDuration}
            ceCredits={product.ceCredits}
            isPurchasable={product.isPurchasable}
            showPrice={product.showPrice}
            retailPrice={product.retailPrice}
            salePrice={product.salePrice}
            courseBundleCount={product.courseBundleCount}
          />
        ))}
      </div>
      {page < pages && (
        <Query
          search={{ page: page + 1 }}
          className="btn btn-block btn-sm btn-outline-primary"
        >
          Show More
        </Query>
      )}
      {loading && <div className="products__results-loading" />}
    </section>
  );
};

Results.propTypes = {
  loading: PropTypes.bool.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape(ProductSearchResult.propTypes)),
  setFiltersVisibility: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired
};

Results.defaultProps = {
  results: undefined
};

export default Results;
